export const USER_COLOR_ARRAY_LIGHT = [
    {
        light: 'var(--data-viz-chart-color-1-subdued)',
        dark: 'var(--color-magenta-70)',
    },
    {
        light: 'var(--data-viz-chart-color-6-subdued)',
        dark: 'var(--color-purple-70)',
    },
    {
        light: 'var(--data-viz-chart-color-2-subdued)',
        dark: 'var(--color-blue-80)',
    },
    {
        light: 'var(--data-viz-chart-color-4-subdued)',
        dark: 'var(--color-green-80)',
    },
    {
        light: 'var(--data-viz-chart-color-7-subdued)',
        dark: 'var(--color-mauve-60)',
    },
    {
        light: 'var(--data-viz-chart-color-3-subdued)',
        dark: 'var(--color-coral-80)',
    },
    {
        light: 'var(--data-viz-chart-color-9-subdued)',
        dark: 'var(--color-yellow-orange-70)',
    },
];

export const USER_COLOR_ARRAY_DARK = [
    {
        light: 'var(--color-pink-20)',
        dark: 'var(--color-pink-110)',
    },
    {
        light: 'var(--color-purple-10)',
        dark: 'var(--color-purple-100)',
    },
    {
        light: 'var(--color-blue-10)',
        dark: 'var(--color-blue-100)',
    },
    {
        light: 'var(--color-green-10)',
        dark: 'var(--color-green-100)',
    },
    {
        light: 'var(--color-magenta-10)',
        dark: 'var(--color-magenta-90)',
    },
    {
        light: 'var(--color-orange-20)',
        dark: 'var(--color-orange-100)',
    },
    {
        light: 'var(--color-yellow-20)',
        dark: 'var(--color-yellow-120)',
    },
];

export function calculateUsernameColor (username, isDarkModeEnabled = false) {
    const usernameArray = username ? [...username] : [];

    const nameValue = usernameArray.reduce((acc, char) => {
        return char.charCodeAt() + acc;
    }, 0);

    const colorArray = isDarkModeEnabled ? USER_COLOR_ARRAY_DARK : USER_COLOR_ARRAY_LIGHT;

    const colorValue = nameValue % colorArray.length;
    const borderColorVariable = `var(--raw-${colorArray[colorValue].dark.slice(6, -1)})`;

    return {
        'background-color': colorArray[colorValue].light,
        'color': colorArray[colorValue].dark,
        'border-color': `rgba(${borderColorVariable}, 0.3)`,
    };
}

export function formatUserFullName ({ first = '', last = '', username = '', fullName = '' }) {
    if (fullName) {
        return fullName;
    }

    if (first && last) {
        return `${first} ${last}`;
    }

    return username;
}
